import { render, staticRenderFns } from "./spectrumAnalysis.vue?vue&type=template&id=d2037c28&scoped=true"
import script from "./spectrumAnalysis.vue?vue&type=script&lang=js"
export * from "./spectrumAnalysis.vue?vue&type=script&lang=js"
import style0 from "./spectrumAnalysis.vue?vue&type=style&index=0&id=d2037c28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2037c28",
  null
  
)

export default component.exports